module.exports = __webpack_public_path__ + "static/media/mobile_banner2.a5e89437.png";